define('OutSystems/ReactWidgets/TextArea',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react", "./Throttling"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React, Throttling_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TextArea = void 0;
    var TextArea = (function (_super) {
        tslib_1.__extends(TextArea, _super);
        function TextArea(props, context) {
            var _this = _super.call(this, props, context) || this;
            _this.state = { value: "" };
            _this.throttling = new Throttling_1.Throttling();
            return _this;
        }
        TextArea.prototype.onChange = function (e) {
            var _this = this;
            var input = e.target;
            this.variable.value = input.value;
            this.setState({ value: input.value });
            if (this.props.onChange) {
                this.throttling.throttle(function () { return _this.props.onChange(); }, this.throttleValue);
            }
        };
        Object.defineProperty(TextArea.prototype, "htmlElement", {
            get: function () {
                return this.getHTMLNode();
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TextArea.prototype, "inputedValue", {
            get: function () {
                return this.htmlElement.value;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TextArea.prototype, "inputedValueValidity", {
            get: function () {
                return this.htmlElement.validity;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TextArea.prototype, "isMandatory", {
            get: function () {
                return this.props.mandatory;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TextArea.prototype, "variable", {
            get: function () {
                return this.props.variable;
            },
            enumerable: false,
            configurable: true
        });
        TextArea.prototype.componentDidMount = function () {
            this.updateValue(this.props.variable.value);
            if (this.props.extendedProperties) {
                var customValue = this.props.extendedProperties[Throttling_1.Throttling.CustomThrottlingProperty];
                if (typeof customValue !== "undefined") {
                    this.throttleValue = parseInt(customValue, 10);
                }
            }
        };
        TextArea.prototype.updateValue = function (value) {
            this.setState({ value: value });
        };
        TextArea.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
            if (this.props.variable.value !== nextProps.variable.value) {
                this.updateValue(nextProps.variable.value);
            }
        };
        TextArea.prototype.componentWillUnmount = function () {
            this.throttling.dispose();
        };
        TextArea.prototype.render = function () {
            var _this = this;
            var textAreaAttributes = {
                "data-textarea": "",
                className: this.props.style,
                disabled: !this.props.enabled,
                required: this.props.mandatory,
                rows: this.props.textLines,
                placeholder: this.props.prompt,
                onChange: function (e) { return _this.onChange(e); },
                value: this.state.value.toString(),
            };
            if (this.props.maxLength > 0) {
                textAreaAttributes.maxLength = this.props.maxLength;
            }
            this.fillWithBuiltinProperties(textAreaAttributes);
            delete textAreaAttributes[Throttling_1.Throttling.CustomThrottlingProperty];
            return React.createElement(HtmlTags_1.HtmlTags.span, null, React.createElement(HtmlTags_1.HtmlTags.textarea, textAreaAttributes), this.createValidationElement());
        };
        TextArea = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], TextArea);
        return TextArea;
    }(Widget_1.InputWithVariableWidget));
    exports.TextArea = TextArea;
});
//# sourceMappingURL=TextArea.js.map;
